
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M15.39 13.04a2.57 2.57 0 00-2.57-2.57 2.565 2.565 0 102.57 2.57m1.71 0a4.274 4.274 0 11-8.05 2A4.274 4.274 0 011 13.11V6c0-.44.39-.82.86-.82s.84.38.85.82v3.62c.72-.54 1.61-.86 2.57-.86 1.63 0 3.05.92 3.77 2.27a4.274 4.274 0 013.77-2.27c2.36 0 4.28 1.92 4.28 4.28m-9.26 0c0-1.42-1.15-2.57-2.56-2.57a2.57 2.57 0 00-2.57 2.57 2.565 2.565 0 105.13 0m15 2.92c.11.16.16.34.16.51 0 .26-.12.53-.34.68a.89.89 0 01-.51.17c-.25 0-.5-.11-.65-.32l-1.91-2.53L17.7 17c-.17.21-.42.32-.67.32-.18 0-.36-.06-.53-.17-.21-.15-.33-.43-.33-.69 0-.17.06-.35.16-.5l2.17-2.92-2.17-2.93a.828.828 0 01-.16-.5c0-.26.12-.51.33-.68.39-.28.91-.21 1.2.16l1.89 2.52 1.91-2.52c.26-.37.79-.44 1.16-.16.23.17.34.43.34.7 0 .17-.05.34-.16.48l-2.18 2.93 2.18 2.92z"}})])
          )
        }
      }
    